import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Checkbox from 'components/Checkbox';
import BodyText from 'components/widget/BodyText';
import ProductPrice from 'components/ProductPrice';

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.colors.white};
  .Checkbox{
    padding: ${({ theme }) => theme.spacing * 3}px ${({ theme }) => theme.spacing * 2}px;
  }
  .checkboxChildrenWrapper {
    margin-left: ${({ theme }) => theme.spacing * 2}px;
  }

  .checkboxBody {
    display: flex;
    justify-content: space-between;
    margin-top: -4px;
    h3 {
      margin:0;
    }

    .heading{
      h2{
        margin: 0 0 ${({ theme }) => theme.spacing}px 0;
      }
      .helpText{
        color: #B3B3B3;
        margin: 8px 0 0;
      }
    }
  }

`;

const IncludeSolutionWidget = ({
  className, solution, onChange, selected, frequency,
}) => {
  const classes = ['IncludeSolutionWidget'];
  if (className) classes.push(className);
  const UNTICKED = 'check this box to include this solution';
  const TICKED = 'uncheck this box to remove this solution';

  const [helpText, setHelpText] = React.useState(selected ? TICKED : UNTICKED);

  useEffect(() => {
    setHelpText(selected ? TICKED : UNTICKED);
  }, [selected]);

  return (

    <Wrapper className={classes.join(' ')}>
      <Checkbox name="includeSolution" onChange={onChange} checked={!!selected}>
        <div className="checkboxBody">
          <div className="heading">
            <h2>
              {solution.name}
            </h2>
            <BodyText>Solution</BodyText>
            <p className="helpText">{helpText}</p>
          </div>
          <h3>
            <ProductPrice
              price={solution.price}
              frequency={frequency}
              currency={solution.currency}
            />
          </h3>
        </div>
      </Checkbox>
    </Wrapper>
  );
};

IncludeSolutionWidget.displayName = 'IncludeSolutionWidget';

IncludeSolutionWidget.propTypes = {
  className: PropTypes.string,
  solution: PropTypes.shape({
    name: PropTypes.string,
    price: PropTypes.number,
    currency: PropTypes.oneOf(['EUR', 'GBP', 'USD']),
  }),
  selected: PropTypes.bool,
  onChange: PropTypes.func,
  frequency: PropTypes.string,
};

IncludeSolutionWidget.defaultProps = {
  className: undefined,
  solution: undefined,
  onChange: undefined,
  selected: false,
  frequency: null,
};

export default IncludeSolutionWidget;
